/**
 * Normalize API base URLs from env vars.
 *
 * Expected backend routes are mounted under `/api`.
 * If an absolute host URL is provided without a path, append `/api`
 * so auth calls do not hit `/auth/*` and 404 with "Cannot POST /auth/login".
 */
export function resolveApiBaseUrl(raw: unknown, fallback: string): string {
  const candidate = String(raw || fallback).trim();
  const normalized = candidate.replace(/\/+$/, "");

  if (!/^https?:\/\//i.test(normalized)) {
    return normalized;
  }

  try {
    const parsed = new URL(normalized);
    const path = parsed.pathname.replace(/\/+$/, "");
    if (path === "" || path === "/") {
      parsed.pathname = "/api";
      return parsed.toString().replace(/\/+$/, "");
    }
    return normalized;
  } catch {
    return normalized;
  }
}

export const VITE_API_URL_REQUIRED_MSG =
  "[VITE_API_URL] Required in production builds but was absent or empty. " +
  "Set VITE_API_URL to this environment's backend API base (including /api) at build time. " +
  "Refusing to default to another environment.";

/**
 * Production API base: fail closed when VITE_API_URL is absent or empty.
 * Callers must not pass a cross-environment hardcoded fallback.
 */
export function resolveProductionApiBaseUrl(raw: unknown): string {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) {
    throw new Error(VITE_API_URL_REQUIRED_MSG);
  }
  return resolveApiBaseUrl(trimmed, trimmed);
}
